import { computed, watch, inject } from 'vue'
import { isObject } from '../utils/helpers'

export default function checkRadioMixin(context) {
  const form = inject('akForm')
  let group

  if (context.props.isGroup) {
    group = inject(
      context.type === 'checkbox' ? 'akCheckboxGroup' : 'akRadioGroup'
    )
  }

  const computedValue = computed({
    get() {
      return context.props.modelValue
    },
    set(value) {
      context.emit('change', value, context.props)
      context.emit('update:modelValue', value)
    },
  })

  /**
   * @returns {Boolean}
   * @description Returns a boolean flag to determine if the input is
   * a checkbox or radio group, we are going to treat these as a
   * single input
   */
  const isCheckRadioGroup = () => {
    return group && (group.isCheckboxGroup || group.isRadioGroup)
  }

  /**
   * @description Callback for the "created" lifecycle events in vue
   * this will be executed when the component is created
   */
  const onMounted = () => {
    if (isCheckRadioGroup()) {
      if (isObject(form) && typeof form.register === 'function') {
        form.register(context.validation)
      }
    }
  }

  /**
   * @description Callback for the "beforeDestroy" lifecycle events in vue
   * this will be executed before the component is removed
   */
  const beforeUnmount = () => {
    if (isCheckRadioGroup()) {
      if (isObject(form) && typeof form.unregister === 'function') {
        form.unregister(context.validation)
      }
    }
  }

  watch(computedValue, () => {
    context.validation.isPristine = false
  })

  return {
    computedValue,
    onMounted,
    beforeUnmount,
  }
}
